<template>
  <Modal title="Title" v-model="showFormModal" class-name="card-modal" :width="action=='view'?600:1350">
    <div slot="header">
      <h4>{{title}}</h4>
    </div>

    <!-- Warning Modal for existing responses -->
    <Modal v-model="showWarningModal" title="Warning" class-name="vertical-center-modal card-modal" :width="500" :closable="false" :mask-closable="false">
      <div class="confirmation-body">
        <p>
          <Icon type="ios-warning" size="48" color="#f90" />
        </p>
        <p style="margin-top: 15px; font-size: 14px;">
          <strong>Warning:</strong> This form already contains recorded responses.
        </p>
        <p style="margin-top: 10px; color: #666;">
          Modifying this form will result in the <strong>loss of all collected data</strong>.
        </p>
        <p style="margin-top: 15px; color: #004f6e;">
          If you wish to keep the existing data, we recommend <strong>creating a new form</strong> instead.
        </p>
      </div>
      <div slot="footer">
        <Button @click="showWarningModal=false; showFormModal=false" class="btn btn-outline-secondary btn-sm">
          Cancel
        </Button>
        <Button type="error" @click="confirmUpdate" class="btn btn-danger btn-sm">
          Modify Anyway
        </Button>
      </div>
    </Modal>

    <Form v-if="action==='view'" ref="formForm" :model="formForm" :rules="ruleValidate">
      <Row class="widget-container">

        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <FormItem label="" :prop="'isActive'">
            <label class="label-answer-viewOnly" :for="formForm.isActive">Active</label>
            <i-switch v-model="formForm.isActive" disabled></i-switch>
          </FormItem>
        </i-col>

        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <FormItem label="" :prop="'title'">
            <div class='full-input-viewOnly'>
              <label class="label-answer-viewOnly" :for="formForm.title">Form Title</label>
              <input readonly style="width: 100%;" type='text' class="input-answer-viewOnly" v-model="formForm.title" />
            </div>
          </FormItem>
        </i-col>

        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <FormItem label="" :prop="'desc'">
            <div class='full-input-viewOnly'>
              <label class="label-answer-viewOnly" :for="formForm.desc">Form Desc</label>
              <input readonly style="width: 100%;" type='text' class="input-answer-viewOnly" v-model="formForm.desc" />
            </div>
          </FormItem>
        </i-col>

        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <div class='full-input-viewOnly'>
            <label class="label-answer-viewOnly" :for="'Questions'">Questions</label>
            <FormItem v-for="(question, ixx) in formForm.questions" :key="ixx" label=""
                      :prop="'questions[' + ixx + '].title'"
                      v-if="question.status&&question.type.toLowerCase()!=='textarea'
                        &&question.fieldCode.toLowerCase()!=='leadrating'">
              <Row>
                <i-col :xs="8" :sm="8" :md="8" :lg="8">
                  <label class="label-answer-viewOnly" :for="question.title">
                    {{question.title}}
                  </label>
                </i-col>
                <i-col :xs="8" :sm="8" :md="8" :lg="8">
                  <label class="label-answer-viewOnly" :for="question.inputType">
                    {{question.inputType}}
                  </label>
                </i-col>
                <i-col :xs="8" :sm="8" :md="8" :lg="8">
                  <FormItem v-for="(choice, ix) in question.choices"
                            :key="ix" :prop="'questions[' + ixx + '].choices[' + ix + '].label'">
                    <Row>
                      <i-col :xs="24" :sm="24" :md="24" :lg="24">
                        <Input v-model="choice.label" :key="ix" style="width: 100%;"
                               :placeholder="'Choice ' + ix" :type="'text'" readonly>
                        </Input>
                      </i-col>
                    </Row>
                  </FormItem>
                </i-col>
              </Row>
            </FormItem>
            <FormItem v-for="(question, index) in formForm.questions"
                      :key="index" :prop="'questions[' + index + '].title'"
                      v-if="question.type.toLowerCase()==='textarea'">
              <Row>
                <i-col :xs="8" :sm="8" :md="8" :lg="8">
                  <label class="label-answer-viewOnly" :for="question.title">
                    {{question.title}}
                  </label>
                </i-col>
                <i-col :xs="16" :sm="16" :md="16" :lg="16">
                  <label class="label-answer-viewOnly" :for="question.inputType">
                    {{question.inputType}}
                  </label>
                </i-col>
              </Row>
            </FormItem>
            <FormItem v-for="(question, index) in formForm.questions"
                      :key="index" :prop="'questions[' + index + '].title'"
                      v-if="question.fieldCode.toLowerCase()==='leadrating'">
              <Row>
                <i-col :xs="24" :sm="24" :md="24" :lg="24">
                  <div class='full-input-viewOnly'>
                    <label class="label-answer" :for="question.title">
                      {{formForm.questions[index].title}}
                    </label>
                    <FormItem label="" :prop="'questions[' + index + '].title'">
                      <Row>
                        <i-col :xs="8" :sm="8" :md="8" :lg="8" align="center">
                          <Button disabled name="Hot" title="HOT" size="large" class="hotButton">
                          </Button>
                        </i-col>
                        <i-col :xs="8" :sm="8" :md="8" :lg="8" align="center">
                          <Button disabled name="Warm" title="WARM" size="large" class="warmButton">
                          </Button>
                        </i-col>
                        <i-col :xs="8" :sm="8" :md="8" :lg="8" align="center">
                          <Button disabled name="Cold" title="COLD" size="large" class="coldButton">
                          </Button>
                        </i-col>
                      </Row>
                    </FormItem>
                  </div>
                </i-col>
              </Row>
            </FormItem>
          </div>
        </i-col>

      </Row>
    </Form>

    <Form v-if="action==='add'" ref="formForm" :model="formForm" :rules="ruleValidate" :label-width="100">
      <Row class="widget-container">
        <i-col :xs="4" :sm="4" :md="4" :lg="4">
          <FormItem label="Active">
            <i-switch v-model="formForm.isActive" :disabled="action==='view' " @on-change="activateItem"></i-switch>
          </FormItem>
        </i-col>
        <i-col :xs="16" :sm="16" :md="16" :lg="16">
          <FormItem label="Existing Forms">
            <Select v-model="selectedFormQuestions" multiple transfer>
              <Option v-for="item in formQuestionList" :value="item.formId" :key="item.formId">
                {{item.formName}}
              </Option>
            </Select>
          </FormItem>
        </i-col>
        <i-col :xs="4" :sm="4" :md="4" :lg="4">
          <Button size="small" type="primary" @click="addDuplicates">Import</Button>
        </i-col>

        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <FormItem label="Form Title" :prop="'title'"
                    :rules="{required: true, message: 'Title cannot be empty', trigger: 'blur'}">
            <Input v-model="formForm.title" :readonly="action==='view'"></Input>
          </FormItem>
        </i-col>
        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <FormItem label="Form Desc" :prop="'desc'">
            <Input v-model="formForm.desc" type="textarea" :autosize="{minRows: 5,maxRows: 10}"
                   placeholder="Enter something..." :readonly="action==='view'">
            </Input>
          </FormItem>
        </i-col>
        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <FormItem v-for="(question, ixx) in formForm.questions"
                    :key="ixx"
                    :label="'Question ' + ixx"
                    :prop="'questions[' + ixx + '].title'"
                    :rules="{required: true, message: 'Question ' + ixx +' cannot be empty', trigger: 'blur'}" class="my-3">
            <Row>
              <i-col :xs="7" :sm="7" :md="7" :lg="7">
                <Input v-model="formForm.questions[ixx].title"
                       :readonly="action==='view'
                         ||question.status===0
                         ||question.fieldCode.toLowerCase()==='id'
                         ||question.fieldCode.toLowerCase()==='firstname'
                         ||question.fieldCode.toLowerCase()==='lastname'
                         ||question.fieldCode.toLowerCase()==='country'
                         ||question.fieldCode.toLowerCase()==='email'">
                </Input>
              </i-col>
              <i-col :xs="3" :sm="3" :md="3" :lg="3">
                <Select @on-change="(e) => changeType(ixx, e)"
                        v-model="question.inputType" placeholder="Select Type"
                        :disabled="action==='view'
                           ||question.fieldCode.toLowerCase()==='id'
                           ||question.fieldCode.toLowerCase()==='firstname'
                           ||question.fieldCode.toLowerCase()==='lastname'
                           ||question.fieldCode.toLowerCase()==='country'
                           ||question.fieldCode.toLowerCase()==='email'
                           ||question.status===0">
                  <Option v-for="type in typeList"
                          :key="type.inputType"
                          :value="type.inputType"><Icon :type="type.iconType"/>
                    {{type.title}}
                  </Option>
                </Select>
              </i-col>
              <i-col :xs="10" :sm="10" :md="10" :lg="10" style="padding: 0">
                <FormItem v-for="(choice, ix) in question.choices"
                          :key="ix"
                          :prop="'questions[' + ixx + '].choices[' + ix + '].label'"
                          :rules="{required: true, message: 'Choice ' + ix +' cannot be empty', trigger: 'blur'}">
                  <Row>
                    <i-col :xs="22" :sm="22" :md="22" :lg="22">
                      <Input v-model="choice.label"
                             :key="ix" style="width: 100%;"
                             :placeholder="'Choice ' + ix"
                             :type="'text'"
                             :readonly="action==='view'||question.status===0
                             ||question.choices===null||question.type==='text'
                             ||question.fieldCode.toLowerCase()==='id'
                             ||question.fieldCode.toLowerCase()==='firstname'
                             ||question.fieldCode.toLowerCase()==='lastname'
                             ||question.fieldCode.toLowerCase()==='country'
                             ||question.fieldCode.toLowerCase()==='email'
                             ||choice.label==='HOT'||choice.label==='WARM'||choice.label==='COLD'">
                      </Input>
                    </i-col>
                    <i-col :xs="2" :sm="2" :md="2" :lg="2">
                      <Button icon="ios-remove-circle-outline" type="error" @click="removeChoice(ixx, ix)"
                              title="Remove" class="btn btn-danger btn-sm" v-if="question.canAddChoices"/>
                    </i-col>
                  </Row>
                </FormItem>
                <FormItem>
                  <Row>
                    <i-col :xs="24" :sm="24" :md="24" :lg="24">
                      <Button icon="ios-add-circle-outline" type="primary" @click="addChoice(ixx)"
                              title="Add New Choice" class="btn btn-primary btn-sm" v-if="question.canAddChoices">
                        Add
                      </Button>
                    </i-col>
                  </Row>
                </FormItem>
              </i-col>
              <i-col :xs="4" :sm="6" :md="4" :lg="4" style="text-align: right">
                <Button
                  class="btn btn-danger btn-sm"
                  :disabled="action==='view'||question.status===0" type="error"
                  v-if="question.fieldCode.toLowerCase()!=='id'
                         &&question.fieldCode.toLowerCase()!=='firstname'
                         &&question.fieldCode.toLowerCase()!=='lastname'
                         &&question.fieldCode.toLowerCase()!=='country'
                         &&question.fieldCode.toLowerCase()!=='email'"
                  @click="handleRemove(ixx)"
                  icon="md-close">
                  Remove
                </Button>
              </i-col>
            </Row>
          </FormItem>
          <FormItem>
            <Button
              :disabled="action==='view'"
              type="info"
              class="btn btn-primary btn-sm"
              @click="handleAdd" icon="md-add">Add Question
            </Button>
          </FormItem>
        </i-col>
      </Row>
    </Form>

    <Form v-if="action==='edit'" ref="formForm" :model="formForm" :rules="ruleValidate" :label-width="100">
      <Row class="widget-container">
        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <FormItem label="Active">
            <i-switch v-model="formForm.isActive" :disabled="action==='view' " @on-change="activateItem"></i-switch>
          </FormItem>
        </i-col>
        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <FormItem label="Form Title" :prop="'title'"
                    :rules="{required: true, message: 'Title cannot be empty', trigger: 'blur'}">
            <Input v-model="formForm.title" :readonly="action==='view'"></Input>
          </FormItem>
        </i-col>
        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <FormItem label="Form Desc" :prop="'desc'">
            <Input v-model="formForm.desc" type="textarea" :autosize="{minRows: 5,maxRows: 10}"
                   placeholder="Enter something..." :readonly="action==='view'">
            </Input>
          </FormItem>
        </i-col>
        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <FormItem v-for="(question, ixx) in formForm.questions"
                    :key="ixx" :label="'Question ' + ixx" :prop="'questions[' + ixx + '].title'"
                    :rules="{required: true, message: 'Question ' + ixx +' cannot be empty', trigger: 'blur'}">
            <Row v-if="question.status">
              <i-col :xs="6" :sm="6" :md="6" :lg="6">
                <Input v-model="formForm.questions[ixx].title"
                       :readonly="action==='view'
                         ||question.status===0
                         ||question.fieldCode.toLowerCase()==='id'">
                </Input>
              </i-col>
              <i-col :xs="4" :sm="4" :md="4" :lg="4">
                <Select @on-change="(e) => changeType(ixx, e)"
                        v-model="question.inputType"
                        :disabled="action==='view'||question.fieldCode.toLowerCase()==='id'||question.status===0">
                  <Option v-for="type in typeList"
                          :key="type.inputType"
                          :value="type.inputType">
                    {{type.title}}
                  </Option>
                </Select>
              </i-col>
              <i-col :xs="10" :sm="10" :md="10" :lg="10" style="padding: 0">
                <FormItem v-for="(choice, ix) in question.choices"
                          :key="ix"
                          :prop="'questions[' + ixx + '].choices[' + ix + '].label'"
                          :rules="{required: true, message: 'Choice ' + ix +' cannot be empty', trigger: 'blur'}">
                  <Row>
                    <i-col :xs="22" :sm="22" :md="22" :lg="22">
                      <Input v-model="choice.label"
                             :key="ix" style="width: 100%;"
                             :placeholder="'Choice ' + ix"
                             :type="'text'"
                             :readonly="action==='view'||question.status===0
                             ||question.choices===null||question.type==='text'
                             ||question.fieldCode.toLowerCase()==='id'
                             ||choice.label==='HOT'||choice.label==='WARM'||choice.label==='COLD'">
                      </Input>
                    </i-col>
                    <i-col :xs="2" :sm="2" :md="2" :lg="2">
                      <Button icon="ios-remove-circle-outline" type="error" @click="removeChoice(ixx, ix)"
                              title="Remove" class="btn btn-danger btn-sm" v-if="question.canAddChoices"/>
                    </i-col>
                  </Row>
                </FormItem>
                <FormItem>
                  <Row>
                    <i-col :xs="24" :sm="24" :md="24" :lg="24">
                      <Button icon="ios-add-circle-outline" type="primary" @click="addChoice(ixx)"
                              title="Add New Choice" class="btn btn-primary btn-sm" v-if="question.canAddChoices">
                        Add
                      </Button>
                    </i-col>
                  </Row>
                </FormItem>
              </i-col>
              <i-col :xs="4" :sm="6" :md="4" :lg="4" style="text-align: right">
                <Button
                  class="btn btn-danger btn-sm"
                  :disabled="action==='view'||question.status===0" type="error"
                  v-if="question.fieldCode.toLowerCase()!=='id'"
                  @click="handleRemove(ixx)"
                  icon="md-close">
                  Remove
                </Button>
              </i-col>
            </Row>
          </FormItem>
          <FormItem>
            <Button :disabled="action==='view'" type="info" class="btn btn-primary btn-sm" @click="handleAdd" icon="md-add">
              Add Question
            </Button>
          </FormItem>
        </i-col>
      </Row>
    </Form>

    <div slot="footer">
      <Button class="btn btn-outline-secondary btn-sm" @click="handleReset;showFormModal=false" style="margin-left: 8px">
        Cancel
      </Button>
      <Button
        class="submit btn btn-success btn-sm"
        type="warning"
        @click="handleCreate('formForm')"
        v-if="action=='add'">
        Create
      </Button>
      <Button size="large" class="submit" type="success" v-if="action=='edit'"
              @click="handleUpdate('formForm',formForm.formId)">Save
      </Button>
    </div>

  </Modal>
</template>

<script>
  import {addForm, updateForm} from '../../services/Forms.service'
  import {getLeadsProcessed} from '../../services/LeadForms.service'
  import {bus} from '../../main'

  export default {
    data() {
      return {
        showCountries: false,
        result: null,
        index: 0,
        action: 'add',
        title: 'ADD FORM',
        showFormModal: false,
        showWarningModal: false,
        hasResponses: false,
        pendingUpdateId: null,
        formForm: {
          formId: '',
          title: '',
          desc: '',
          isActive: false,
          questions: [{
            index: 0,
            status: 0,
            allowOther: false,
            fieldCode: '',
            headerTag: '',
            formId: 0,
            inputType: '',
            order: 0,
            questionId: 0,
            title: '',
            type: '',
            visible: false,
            choices: [{
              actionOnSync: null,
              choiceId: 0,
              label: '',
              order: 0,
              questionId: 0
            }]
          }]
        },
        typeList: [
          {type: 'text', inputType: 'text', title: 'Free Text', iconType: 'ios-menu-outline'},
          {
            type: 'textArea', inputType: 'textArea', title: 'Free Text field (multiple lines)',
            iconType: 'ios-menu-outline'
          },
          {type: 'text', inputType: 'country', title: 'Country', iconType: 'ios-flag-outline'},
          {type: 'text', inputType: 'date', title: 'Date', iconType: 'ios-calendar-outline'},
          {type: 'text', inputType: 'email', title: 'Email', iconType: 'ios-mail-outline'},
          {type: 'text', inputType: 'phoneNumber', title: 'Phone', iconType: 'ios-call-outline'},
          {type: 'leadRating', inputType: 'leadRating', title: 'Lead Rating', iconType: 'ios-star-outline'},
          {type: 'checkbox', inputType: 'multiChoice', title: 'Multiple Choice', iconType: 'ios-checkbox-outline'},
          {type: 'radioList', inputType: 'singleChoice', title: 'Single Choice', iconType: 'ios-radio-button-on'},
          // Hidden options - Photo and Scan
          // {type: 'photo', inputType: 'photo', title: 'Photo', iconType: 'ios-image-outline'},
          // {type: 'QRCode', inputType: 'scan', title: 'Scan', iconType: 'ios-qr-scanner'},
        ],
        indeterminate: null,
        checkAll: false,
        ruleValidate: {},
        spinShow: true,
        selectedFormQuestions: '',
        formQuestionList: [],
      }
    },
    methods: {
      getTimeStamp() {
        let dtNum = new Date().getTime();
        let dt = parseInt(dtNum.toString().substring(7, dtNum.toString().length));
        return dt;
      },
      openForm(title, action, allQuestions) {
        this.handleReset();
        this.showFormModal = true;
        this.title = title;
        this.action = action;
        if (action === 'add') {
          this.formForm.questions = [];
          this.formForm.isActive = true;
          this.formQuestionList = allQuestions;
        }
      },
      handleCreate(name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            let selectedEvent = JSON.parse(localStorage.getItem('events'))
              .find(a => a.eventId == localStorage.getItem('selected_event'));

            if (selectedEvent) {
              let eventId = selectedEvent.eventId;

              const data = Object.assign({}, this.formForm);

              if (localStorage.getItem('role') != 'admin') {
                data['companyId'] = parseInt(localStorage.getItem('companyId'));
              }

              data['formId'] = 0;
              data['title'] = data.title;
              data['desc'] = data.desc;
              data['questions'] = data.questions;
              data['isActive'] = data.isActive;
              data['companyId'] = data.companyId;
              data['eventId'] = eventId;
              data['order'] = 0;
              data['isLeadForm'] = true;
              data['isSurveyForm'] = false;
              data['leadFormIds'] = null;
              data['surveyFormIds'] = null;

              this.showFormModal = false;
              console.log("_formForm.vue - handleCreate");
              addForm(data).then(response => {
                data['formId'] = response.data.formId;
                this.$emit('addForm', data);
                this.$Message.success('Form successfully added!');
                bus.$emit('changeForm', localStorage.getItem('selected_event'));
              })
              .catch(error => {
                console.log(error.response)
                if (error.response.request.responseText) {
                  let errResponse = JSON.parse(error.response.request.responseText)
                  Object.keys(errResponse).map(key => {
                    errResponse[key].map(errMsg => {
                      this.$Message.error(errMsg);
                    })
                  })
                } 
                else {
                  this.$Message.error('Failed adding form');
                }
              });
            }
            else {
              this.$Message.error("LeadForm creation failed : Can't find the selected event");
            }
          }
        })
      },
      handleUpdate(name, id) {
        this.$refs['formForm'].validate((valid) => {
          if (valid) {
            this.pendingUpdateId = id;
            // Check if responses exist for this form
            this.checkForResponses(id).then(hasResponses => {
              if (hasResponses) {
                // Show warning modal
                this.showWarningModal = true;
              } else {
                // No responses, proceed with update
                this.performUpdate(id);
              }
            }).catch(error => {
              console.log('Error checking responses:', error);
              // In case of error, proceed with update
              this.performUpdate(id);
            });
          }
        })
      },
      checkForResponses(formId) {
        return new Promise((resolve, reject) => {
          let selectedEvent = JSON.parse(localStorage.getItem('events'))
            .find(a => a.eventId == localStorage.getItem('selected_event'));

          if (selectedEvent) {
            let companyId = localStorage.getItem('companyId');
            let eventId = selectedEvent.eventId;

            getLeadsProcessed(false, companyId, eventId)
              .then(response => {
                // Filter responses for this specific form
                let formResponses = response.data.filter(r => r.formId === formId);
                resolve(formResponses.length > 0);
              })
              .catch(error => {
                reject(error);
              });
          } else {
            resolve(false);
          }
        });
      },
      confirmUpdate() {
        this.showWarningModal = false;
        this.performUpdate(this.pendingUpdateId);
      },
      performUpdate(id) {
        this.showFormModal = false;
        const data = Object.assign({}, this.formForm);

        if (localStorage.getItem('role') != 'admin') {
          data['companyId'] = parseInt(localStorage.getItem('companyId'));
        }

        data['companyId'] = parseInt(localStorage.getItem('companyId'));
        updateForm(id, data).then(response => {
          this.$emit('updateForm', id, data);
          this.$Message.success('Form successfully update!');
          bus.$emit('changeForm', localStorage.getItem('selected_event'));
        }).catch(error => {
          this.$Message.error('Failed updating form');
        });
      },
      setFormValue(params, index) {
        if (params.questions == null || params.questions.length == 0) {
          params.questions = [];
        }
        params.questions
          .map((x, i) => {
            let title = x.title.toLowerCase();
            let fieldCode = x.fieldCode.toLowerCase();
            if (fieldCode === 'id' || title.toUpperCase() === 'ID') {
              x.status = false;
            }
            if (fieldCode.indexOf('barcode') > -1 || fieldCode.indexOf('codebarre') > -1) {
              i = 0;
            }
            if (x.inputType.toLowerCase() === 'multichoice') {
              x.type = 'checkbox';
              x.fieldCode = 'checkbox';
            }
            if (x.inputType.toLowerCase() === 'leadrating') {
              x.type = 'leadRating';
              x.fieldCode = 'leadRating';
            }
            if (x.inputType.toLowerCase() === 'singlechoice') {
              x.type = 'radioList';
              x.fieldCode = 'radioList';
            }
            if (x.inputType.toLowerCase() === 'email') {
              x.type = 'text';
              x.fieldCode = 'email';
            }
            if (x.inputType.toLowerCase() === 'phonenumber') {
              x.type = 'text';
              x.fieldCode = 'phoneNumber';
            }
            if (x.inputType.toLowerCase() === 'text') {
              x.type = 'text';
              x.fieldCode = 'text';
            }
            if (x.inputType.toLowerCase() === 'country') {
              x.type = 'text';
              x.fieldCode = 'country';
            }
            if (x.inputType.toLowerCase() === 'date') {
              x.type = 'date';
              x.fieldCode = 'date';
            }
            if (x.inputType.toLowerCase() === 'buttons') {
              x.type = 'buttonGroup';
              x.fieldCode = 'buttonGroup';
            }
            if (x.inputType.toLowerCase() === 'textarea') {
              x.type = 'textArea';
              x.fieldCode = 'textArea';
            }
            if (x.inputType.toLowerCase() === 'photo') {
              x.type = 'photo';
              x.fieldCode = 'photo';
            }
            if (x.inputType.toLowerCase() === 'scan') {
              x.type = 'QRCode';
              x.fieldCode = 'scan';
            }
            x.index = i;
            x.status = 1;
          });
        let data = Object.assign({}, params);
        delete data['_index'];
        delete data['_rowKey'];
        this.formForm = data;
      },
      handleReset() {
        this.$refs['formForm'].resetFields();
        this.selectedFormQuestions = '';
        this.formQuestionList = [];
        let self = this;
        Object.keys(this.formForm).forEach(function (key, i) {
          self.formForm[key] = '';
        });
      },
      handleAdd() {
        let dt = this.getTimeStamp();
        if (!this.formForm.questions) {
          this.formForm.questions = [{
            index: 0,
            status: 1,
            questionId: dt,
            title: '',
            type: 'text',
            formId: this.formForm.formId,
            inputType: 'text',
            fieldCode: '',
            headerTag: 'other-' + dt.toString(),
            order: dt,
            visible: true,
            allowOther: false,
            choices: null
          }];
        } else {
          let newRow = {
            index: this.formForm.questions.length,
            status: 1,
            questionId: dt,
            title: '',
            type: 'text',
            formId: this.formForm.formId,
            inputType: 'text',
            fieldCode: '',
            headerTag: 'other-' + dt.toString(),
            order: dt,
            visible: true,
            allowOther: false,
            choices: null
          };
          this.formForm.questions.push(newRow);
        }
      },
      handleRemove(index) {
        if (this.formForm.questions) {
          this.formForm.questions.splice(index, 1);
        }
      },
      changeType(index, choiceLabel) {
        let status = false;
        let question = this.formForm.questions[index];
        question.status = true;
        question.canAddChoices = false;
        question.choices = null;

        if (choiceLabel === 'text') {
          question.type = 'text';
          question.inputType = 'text';
        }
        if (choiceLabel === 'photo') {
          question.type = 'photo';
          question.inputType = 'photo';
        }
        if (choiceLabel === 'scan') {
          question.type = 'QRCode';
          question.inputType = 'scan';
        }
        if (choiceLabel === 'country') {
          question.type = 'text';
          question.inputType = 'country';
        }
        if (choiceLabel === 'date') {
          question.type = 'text';
          question.inputType = 'date';
        }
        if (choiceLabel === 'email') {
          question.type = 'text';
          question.inputType = 'email';
        }
        if (choiceLabel === 'phoneNumber') {
          question.type = 'text';
          question.inputType = 'phoneNumber';
        }
        if (choiceLabel === 'textArea') {
          question.type = 'textArea';
          question.inputType = 'textArea';
        }
        if (choiceLabel === 'leadRating') {
          question.fieldCode = 'leadRating';
          question.type = 'leadRating';
          question.inputType = 'leadRating';
          question.choices = [];
          question.choices.push({
            actionOnSync: '',
            choiceId: parseInt(question.questionId.toString() + "0"),
            label: 'HOT',
            order: 0,
            questionId: question.questionId,
            status: status
          }, {
            actionOnSync: '',
            choiceId: parseInt(question.questionId.toString() + "1"),
            label: 'WARM',
            order: 1,
            questionId: question.questionId,
            status: status
          }, {
            actionOnSync: '',
            choiceId: parseInt(question.questionId.toString() + "2"),
            label: 'COLD',
            order: 2,
            questionId: question.questionId,
            status: status
          });
        }
        if (choiceLabel === 'multiChoice') {
          question.type = 'checkbox';
          question.inputType = 'multiChoice';
          question.canAddChoices = true;
        }
        if (choiceLabel === 'singleChoice') {
          question.type = 'radioList';
          question.inputType = 'singleChoice';
          question.canAddChoices = true;
        }
      },
      addChoice(index) {
        if (!this.formForm.questions[index].choices) {
          this.formForm.questions[index].choices = [];
        }
        let newRow = {
          actionOnSync: '',
          choiceId: parseInt(this.formForm.questions[index].questionId.toString() +
            this.formForm.questions[index].choices.length.toString()),
          questionId: this.formForm.questions[index].questionId,
          label: '',
          order: this.formForm.questions[index].choices.length + 1,
          status: false
        };
        this.formForm.questions[index].choices.push(newRow);
      },
      removeChoice(questionIndex, choiceIndex) {
        this.formForm.questions[questionIndex].choices.splice(choiceIndex, 1);
      },
      activateItem(val) {
        if (val) {
          this.$Message.warning('This will disable all other lead forms!');
        }
      },
      addDuplicates() {
        const self = this;
        if (!self.formForm.questions) {
          self.formForm.questions = [];
        }
        if (self.selectedFormQuestions) {
          self.selectedFormQuestions.map(s => {
            let item = self.formQuestionList.filter(a => a.formId === s);
            let hasData = item !== null ? (item.length > 0 ? true : false) : false;
            if (hasData) {
              let hasQuestions = item[0].questions !== null ? (item[0].questions.length > 0 ? true : false) : false;
              if (hasQuestions) {
                item[0].questions.map(q => {
                  q.canAddChoices = false;
                  if (q.inputType.toLowerCase() === 'multichoice' || q.inputType.toLowerCase() === 'singlechoice') {
                    q.canAddChoices = true;
                  }
                  let exists = self.formForm.questions.filter(a => a.title === q.title);
                  if (exists) {
                    if (exists.length > 0) {
                    } else {
                      self.formForm.questions.push(q);
                    }
                  } else {
                    self.formForm.questions.push(q);
                  }
                });
              }
            }
          })
        }
      },
      getQuestionIcon(question) {
        let iconType = "";
        let type = question.inputType.toLowerCase();

        if (type === 'email') {
          iconType = 'ios-mail-outline';
        }
        if (type === 'phonenumber') {
          iconType = 'ios-call-outline';
        }
        if (type === 'text') {
          iconType = 'ios-menu-outline';
        }
        if (type === 'date') {
          iconType = 'ios-calendar-outline';
        }
        if (type === 'textarea') {
          iconType = 'ios-menu-outline';
        }
        if (type === 'multichoice') {
          iconType = 'ios-checkbox-outline';
        }
        if (type === 'leadrating') {
          iconType = 'ios-star-outline';
        }
        if (type === 'singlechoice') {
          iconType = 'ios-radio-button-on';
        }
        if (type === 'country') {
          iconType = 'ios-flag-outline';
        }
        if (type === 'photo') {
          iconType = 'ios-image-outline';
        }
        if (type === 'scan') {
          iconType = 'ios-qr-scanner';
        }
        return iconType;
      },
    }
  }
</script>

<style scoped>
  .ivu-input, .ivu-btn {
    border: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/b_MyLeadForms/_formForm.vue